
	import { Vue, Component, Prop } from "vue-property-decorator";
	import { MessageType, IMessage } from "@common/Message";
	import { IModelBase } from "@common/data/IModelBase";
	import MessageView from "@components/MessageView.vue";
	import ResourceHelper from "@common/globalization/ResourceHelper";
	import ApiContactForms from "../ApiContactForms";
	import { FormRequestType } from "../FormRequestType";

	declare function getDetailPageUrl(): any;

	@Component({
		name: "search-request-form",
		components: {
			MessageView
		}
	})
	export default class SearchRequestForm extends Vue {
		loading: boolean = false;
		messages: IMessage[] = [];

		from: string = "";
		title: string = "";
		titleCount: number = 1;
		telephone: string = "";
		comment: string = "";

		client: ApiContactForms;

		@Prop({ default: "" })
		searchKeyword: string;

		@Prop({ default: "Advanced search" })
		advancedSearchText: string;

		@Prop({ default: 0 })
		mode!: number;

		@Prop({ default: "" })
		helpText: string;

		@Prop({ default: "Send" })
		okTitle: string;

		@Prop({ default: "Cancel" })
		cancelTitle: string;

		beforeCreate() {
			this.client = new ApiContactForms();
		}

		mounted() {
			this.loading = true;
			this.client.userData()
				.then((data: IModelBase) => {
					this.from = data["Email"];
					this.telephone = data["PhoneNumber"];
				}).catch(err => {
					// WTF?
					
					this.messages.push({
						type: MessageType.Error,
						content: err.toString()
					} as IMessage)
				}).finally(() => {
					this.loading = false;
				});
			this.title = this.searchKeyword;
		}

		created() {
			console.log(`${this.$options.name} created`);
		}

		protected gotoAdvancedSearch(): void {
			const advUrl = getDetailPageUrl() || '';
			if (!advUrl) return;
			window.location.href = advUrl;
		}

		protected onSubmit() {
			if (this.loading) return;
			this.messages.length = 0;

			// make the request
			const data = {
				from: this.from,
				searchKeyword: this.searchKeyword,
				title: this.title,
				titleCount: this.titleCount,
				telephone: this.telephone,
				comment: this.comment
			} as IModelBase;

			this.loading = true;
			// send the data
			this.client.contactFormRequest(FormRequestType.SearchRequest, data)
				.then(() => {
					// update
					this.messages.push({
						type: MessageType.Success,
						content: this.getString("formContentSent")
					} as IMessage);
					this.$emit('submit');
				}).catch(err => {
					// WTF?
					
					this.messages.push({
						type: MessageType.Error,
						content: err.toString()
					} as IMessage);
				}).finally(() => {
					this.loading = false;
				});
		}

		protected getString(name: string, defaultValue: string = ""): string {
			if (!name) return "";
			return ResourceHelper.getString(name, defaultValue);
		}
	}
